class BrandStatement extends HTMLElement {
  connectedCallback() {
    this._initSwiper();
    this._initTickerTouch();
  }

  disconnectedCallback() {
    if (this._swiper) this._swiper.destroy(true, true);
  }

  _playActiveVideo() {
    const activeSlide = this._swiper?.slides?.[this._swiper.activeIndex];
    if (!activeSlide) return;

    this.querySelectorAll('.brand-statement__video').forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });

    const activeVideo = activeSlide.querySelector('.brand-statement__video');
    if (activeVideo) activeVideo.play().catch(() => {});
  }

  _initTickerTouch() {
    const ticker = this.querySelector('.brand-statement__ticker');
    if (!ticker) return;

    ticker.addEventListener('touchstart', () => ticker.classList.add('is-paused'), { passive: true });
    ticker.addEventListener('touchend', () => ticker.classList.remove('is-paused'), { passive: true });
    ticker.addEventListener('touchcancel', () => ticker.classList.remove('is-paused'), { passive: true });
  }

  _initSwiper() {
    const swiperEl = this.querySelector('.brand-statement__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const speed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
    const loop = this.dataset.loop !== 'false';
    const autoplayEnabled = this.dataset.autoplayEnabled !== 'false';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const paginationEl = this.querySelector('.brand-statement__pagination');

    this._swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: loop,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: (!autoplayEnabled || prefersReduced) ? false : {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
      } : false,
      on: {
        slideChangeTransitionStart: () => this._playActiveVideo(),
      },
    });

    this._playActiveVideo();
  }
}

customElements.define('brand-statement', BrandStatement);
